import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import { HYDRATE } from 'next-redux-wrapper';

import type { HydrateAction } from 'redux-store';

import type { ProductsTypeV3 } from '../../products/products.types';
import type { IMobilePaymentInitialState } from './interfaces';
import { MobilePaymentStateEnum, MobilePaymentStatusEnum } from './interfaces';

const initialState: IMobilePaymentInitialState = {
  isVisible: false,
  isLoadingCard: true,
  isLoadingButton: true,
  isProcessing: false,
  state: MobilePaymentStateEnum.DEFAULT,
  walletCardId: null,
  modalType: 'Auth',
  status: MobilePaymentStatusEnum.DEFAULT,
};

export const mobilePayment = createSlice({
  name: 'mobilePayment',
  initialState,
  reducers: {
    show(
      state,
      {
        payload,
      }: PayloadAction<
        Pick<
          IMobilePaymentInitialState,
          'product' | 'coupon' | 'state' | 'modalType'
        >
      >,
    ) {
      state.isVisible = true;
      state.product = payload.product;
      state.coupon = payload.coupon;
      state.state = payload.state;
      state.modalType = payload.modalType;
    },
    close(state) {
      state.isVisible = false;
      state.state = MobilePaymentStateEnum.DEFAULT;
      state.walletCardId = null;
      state.isLoadingCard = true;
      state.isLoadingButton = true;
      state.isProcessing = false;
      state.modalType = 'Auth';
      delete state.product;
      delete state.coupon;
      delete state.paymentType;
    },
    setProduct(state, { payload }: PayloadAction<{ product: ProductsTypeV3 }>) {
      state.product = payload.product;
    },
    setState(
      state,
      { payload }: PayloadAction<{ newState: MobilePaymentStateEnum }>,
    ) {
      state.state = payload.newState;
    },
    setWalletCard(
      state,
      { payload }: PayloadAction<{ walletCardId: string | null }>,
    ) {
      state.walletCardId = payload.walletCardId;
    },
    setLoadingCard(state, { payload }: PayloadAction<{ isLoading: boolean }>) {
      state.isLoadingCard = payload.isLoading;
    },
    setLoadingButton(
      state,
      { payload }: PayloadAction<{ isLoading: boolean }>,
    ) {
      state.isLoadingButton = payload.isLoading;
    },
    setProcessingStart(state) {
      state.isProcessing = true;
    },
    setProcessingEnd(state) {
      state.isProcessing = false;
    },
    setProcessingStatus(
      state,
      { payload }: PayloadAction<{ status: MobilePaymentStatusEnum }>,
    ) {
      state.status = payload.status;
    },
    setPaymentType(state, { payload }: PayloadAction<string>) {
      state.paymentType = payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(
      HYDRATE,
      (state, { payload }: HydrateAction<IMobilePaymentInitialState>) => {
        return payload.mobilePayment;
      },
    );
  },
});
